import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';

function Histogram({ options, data }) {
  return <Bar options={options} data={data} />;
}

export default Histogram;

Histogram.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  options: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};
